import React from 'react';
import { WX_COLOR, LUCK_COLOR, HARM_COLOR, GAN_WX } from '../qimen/colors.js';
import { STARS, MENS, SHEN_LUCK, GONG_BY_NUM } from '../qimen/constants.js';
import {
  GAN_MEANINGS, SHEN_MEANINGS, STAR_MEANINGS, MEN_MEANINGS,
  KONG_MEANING, HARM_MEANING,
} from '../qimen/meanings.js';

const STAR_BY = Object.fromEntries(STARS.map(s => [s.name, s]));
const MEN_BY = Object.fromEntries(MENS.map(m => [m.name, m]));

const SHENG = { 木: '火', 火: '土', 土: '金', 金: '水', 水: '木' };
function relation(wxA, wxB) {
  if (!wxA || !wxB) return null;
  if (wxA === wxB) return { text: '比和', desc: '五行相同，主平顺稳定、势均力敌' };
  if (SHENG[wxA] === wxB) return { text: `${wxA}生${wxB}`, desc: '天盘干生地盘干，主和美相生、事易得助' };
  if (SHENG[wxB] === wxA) return { text: `${wxB}生${wxA}`, desc: '地盘干生天盘干，主上有来源、下有根基' };
  const KE = (a, b) => SHENG[SHENG[a]] === b; // 相隔一位即所克
  if (KE(wxA, wxB)) return { text: `${wxA}克${wxB}`, desc: '天盘干克地盘干，主我制彼、可主动成事但耗力' };
  if (KE(wxB, wxA)) return { text: `${wxB}克${wxA}`, desc: '地盘干克天盘干，主彼制我、受制受阻宜静守' };
  return null;
}

function Section({ title, color, children }) {
  return (
    <section className="detail-sec">
      <h4 style={color ? { color } : undefined}>{title}</h4>
      {children}
    </section>
  );
}

export default function PalaceModal({ p, onClose }) {
  if (!p) return null;
  const g = GONG_BY_NUM[p.num];
  const kongs = p.harms.filter(h => h.type === '空亡' && h.label === '时空'); // 只显示时空亡
  const others = p.harms.filter(h => h.type !== '空亡');
  const rel = relation(GAN_WX[p.tianpan[0]], GAN_WX[p.dipan]);

  return (
    <div className="modal-mask" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <header className="modal-head">
          <h3>
            <span style={{ color: WX_COLOR[p.wx] }}>{p.gua}</span>
            {p.num === 5 ? '中五宫' : `第${p.num}宫`} · {p.dir}
            <small className="head-zhis">{g.zhis.length ? `（含${g.zhis.join('、')}）` : ''}</small>
          </h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </header>

        {p.center ? (
          <>
            <Section title="中五宫 · 皇极之位">
              <p className="sec-text">
                中五宫为太极之位，不落星、门；天禽星寄坤二宫随天芮同行。
                地盘干 <b style={{ color: WX_COLOR[GAN_WX[p.dipan]] }}>{p.dipan}</b>
                （{GAN_WX[p.dipan]}）—— {GAN_MEANINGS[p.dipan]?.text}
              </p>
            </Section>
            {p.shen && (
              <Section title="九神 · 太常" color="#8a6fc0">
                <p className="sec-text">
                  <b>{p.shen}（{SHEN_MEANINGS[p.shen]?.luck}）</b>：{SHEN_MEANINGS[p.shen]?.text}
                </p>
              </Section>
            )}
          </>
        ) : (
          <>
            {/* ---- 神星门干总览 ---- */}
            <div className="modal-grid">
              <div className="kv"><i>八神</i><em style={{ color: LUCK_COLOR[SHEN_LUCK[p.shen]] }}>{p.shen}（{SHEN_LUCK[p.shen]}）</em></div>
              <div className="kv"><i>八门</i><em>{p.men && `${p.men}·${MEN_BY[p.men].luck}`}</em></div>
              <div className="kv"><i>九星</i><em>{p.stars.map(s => `${s}·${STAR_BY[s].luck}`).join(' / ')}</em></div>
              <div className="kv"><i>天地盘</i><em>{p.tianpan.join('')} / {p.dipan}</em></div>
            </div>

            {p.isZhiFu && <p className="modal-flag fu">此宫为<b>值符</b>之宫（天盘旬首仪所临，万神之首）</p>}
            {p.isZhiShi && <p className="modal-flag shi">此宫为<b>值使</b>之门所落（事体动向之门）</p>}
            {p.isMa && <p className="modal-flag ma">驿马临宫 —— 主变动、出行、奔波、迁移之事</p>}

            {/* ---- 八神释义 ---- */}
            <Section title={`神 · ${p.shen}`} color={LUCK_COLOR[SHEN_LUCK[p.shen]]}>
              <p className="sec-text">{SHEN_MEANINGS[p.shen]?.text || '—'}</p>
            </Section>

            {/* ---- 九星释义 ---- */}
            <Section title={`星 · ${p.stars.join('、')}`} color="#000088">
              {p.stars.map((s) => {
                const st = STAR_BY[s];
                return (
                  <p key={s} className="sec-text">
                    <b>{s}</b>（{st.wx}·{st.luck}）：{STAR_MEANINGS[s]?.text}
                  </p>
                );
              })}
            </Section>

            {/* ---- 八门释义 ---- */}
            {p.men && (
              <Section title={`门 · ${p.men}`} color="#005500">
                <p className="sec-text">
                  <b>{p.men}</b>（{MEN_BY[p.men].wx}·{MEN_BY[p.men].luck}）：{MEN_MEANINGS[p.men]?.text}
                </p>
                {others.some(h => h.type === '门迫') && (
                  <p className="sec-warn" style={{ color: HARM_COLOR['门迫'] }}>⚠ 此门克本宫，构成「门迫」—— {HARM_MEANING['门迫']}</p>
                )}
              </Section>
            )}

            {/* ---- 天地盘干释义 + 生克 ---- */}
            <Section title="干 · 天地盘">
              {p.tianpan.map((gan) => (
                <p key={gan} className="sec-text">
                  <b style={{ color: WX_COLOR[GAN_WX[gan]], fontSize: 16 }}>天盘 {gan}</b>
                  （{GAN_WX[gan]} · {GAN_MEANINGS[gan]?.tag}）：{GAN_MEANINGS[gan]?.text}
                </p>
              ))}
              <p className="sec-text">
                <b style={{ color: WX_COLOR[GAN_WX[p.dipan]], fontSize: 16 }}>地盘 {p.dipan}</b>
                （{GAN_WX[p.dipan]} · {GAN_MEANINGS[p.dipan]?.tag}）：{GAN_MEANINGS[p.dipan]?.text}
              </p>
              {rel && (
                <p className="sec-rel">天地盘关系：<b>{rel.text}</b> —— {rel.desc}</p>
              )}
            </Section>

            {/* ---- 空亡细节（圆圈标记对应的详细说明）---- */}
            {kongs.length > 0 && (
              <Section title="空亡细节" color={HARM_COLOR['空亡']}>
                {kongs.map((h, i) => (
                  <p key={i} className="sec-text">
                    <span className="kong-inline" title="时空亡" />
                    <b>{h.label}</b>：{h.detail}
                  </p>
                ))}
                <p className="sec-note">{KONG_MEANING}</p>
              </Section>
            )}

            {/* ---- 其余四害判定 ---- */}
            <Section title="四害判定">
              {others.length === 0
                ? <p className="none">本宫无门迫／击刑／入墓。</p>
                : others.map((h, i) => (
                  <p key={i} className="harm-item">
                    <b style={{ background: HARM_COLOR[h.type] }}>{h.label || h.type}</b>
                    <span>{h.detail} —— {HARM_MEANING[h.type] || ''}</span>
                  </p>
                ))}
            </Section>
          </>
        )}
      </div>
    </div>
  );
}
